import FirstDataApplePay from './ApplePay'
import FirstDataCreditCard from './CreditCard'
import FirstDataGooglePay from './GooglePay'

export {
  FirstDataCreditCard,
  FirstDataApplePay,
  FirstDataGooglePay,
}



// WEBPACK FOOTER //
// ./src/components/first-data/index.js